import { z } from 'zod';
import { makeSummaryFilterSchema, makeSummaryParamsSchema } from './pagination.js';
export const AppointmentSummaryFieldSchema = z.enum([
    'id',
    'jobId',
    'channel',
    'date',
    'type',
    'isCompleted',
    'participants',
    'subcontractorId',
    'fieldTechnicianId',
]);
export const AppointmentSummaryFilterSchema = makeSummaryFilterSchema(AppointmentSummaryFieldSchema);
export const AppointmentSummariesParamsSchema = z.object({
    filter: makeSummaryParamsSchema(AppointmentSummaryFieldSchema, AppointmentSummaryFilterSchema)
        .shape.filter,
});
